<template>
    <post-detail-link :detailLayout="detailLayout" :postData='postData'></post-detail-link>
</template>

<script>
import PostDetailLink from "@/components/post/PostDetailLink";
import postUtil from "@/components/post/postUtil";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import {mapState} from "vuex";
import DeleteClass from "@/mixins/deleteClass";
import axios from "axios";

export default {
    name: "PostDetailComponent",
    mixins: [postUtil, alertMixins,],
    components: {
        PostDetailLink
    },
    provide() {
        return {
            postLiveLDownload: this.liveDownload,
        }
    },
    inject: ['setLiveStatus', 'changeLoading'],
    props: {
        postType: '',
        postKey: {
            default: 0
        },
    },
    data() {
        return {
            detailLayout: '',
            getFunc: '',
            detailApiParamSet: {},
            postData: {},

            deleteFunc: '',
            deleteApiParamSet: {},
            deleteSuccessType: 1,
            deleteErrorTypes: {},

            keyName: 'wr_id',
            sendType: 'post',
            DeleteClass: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initFilterConfig()
        if (this.postKey !== 0) {
            this.getDetail()
        } else {
            this.initTempConfig()
        }
    },
    mounted() {
        EventBus.$on('setPostDelete', this.deletePost);
        EventBus.$on('getPostDetail', this.getDetail);
        EventBus.$on('deleteElastic', this.deleteElastic);
    },
    beforeDestroy() {
        EventBus.$off('setPostDelete');
        EventBus.$off('getPostDetail');
        EventBus.$off('deleteElastic');
    },
    methods: {
        initFilterConfig() {
            let configPost = this.returnPostConfig(this.postType);
            this.getFunc = configPost.getFunc;
            this.detailApiParamSet = configPost.detailApiParamSet;

            this.deleteFunc = configPost.deleteFunc;
            this.deleteApiParamSet = configPost.deleteApiParamSet;
            this.deleteSuccessType = configPost.deleteSuccessType;
            this.deleteErrorTypes = configPost.deleteErrorTypes;
            this.keyname = configPost.keyName;
            this.sendType = configPost.sendType;

            this.newDeleteClass();
        },
        initTempConfig() {
            let configPost = this.returnPostConfig(this.postType);
            this.detailLayout = configPost.detailLayout;

        },
        newDeleteClass() {
            let options = {
                func: this.$api.$post[this.deleteFunc],
                apiParamSet: this.deleteApiParamSet,
                keyName: this.keyName,
                successType: this.deleteSuccessType,
                errorTypes: this.deleteErrorTypes,
                afterFunc: this.deleteAfterFunc,
            }

            this.DeleteClass = new DeleteClass(options);
        },
        getDetail() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamSet))
            params.id = this.postKey
            this.$api.$post[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 200 && res.Info.List.length < 0) {
                    this.createAlert({
                        content: '게시글을 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    })
                    return false;
                }
                if (util.isEmpty(res.List)) {
                    this.createAlert({
                        content: '게시글을 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    })
                    return false;
                }
                this.postData = res.List[0];
                if(!util.isEmpty(this.postData.bj_live) && !util.isEmpty(this.setLiveStatus)) {
                    this.setLiveStatus(this.postData.bj_live);
                }
            }).then()
            this.initTempConfig()

        },
        deletePost() {
            this.createConfirm({
                content: '삭제하시겠습니까?',
                confirmText: '예',
                cancelText: '아니오',
                confirm: () => {
                    this.runDelete();
                }
            })
        },
        runDelete() {
            this.DeleteClass.runDelete(this.postKey);
        },
        deleteAfterFunc(key) {
            this.deleteElastic(key);
        },
        deleteElastic(wr_id, type) {
            this.changeLoading(true);
            let params = {
                key: wr_id,
                type: this.sendType,
            }
            try {
                this.$api.$elastic.deleteElastic(params).then(res => res.Data.Result).then(res => {
                    setTimeout(() => {
                        EventBus.$emit('elasticListDeleteAfter', this.keyName, this.postKey);
                        if (res.Info.type != 1) {
                            this.errorAlert(res.Info.type);
                        } else {
                            this.createAlert({
                                content: '삭제되었습니다.',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                        }
                        this.changeLoading(false);
                    }, 500)
                })
            } catch (e) {
                this.changeLoading(false);
                console.log(e)
            }
        },
        commentAfterFunc(data) {
            if (data === 'create') {
                this.postData.Comment.cnt++;
            } else {
                this.postData.Comment.cnt--;
            }

        },

        liveDownload() {
            this.changeLoading(true);
            let params ={wr_id : this.postKey}
            try {
                this.$api.$post.downloadLive(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type != 1){
                        this.errorAlert('다운로드에 실패하였습니다.')
                        return false
                    }
                    let type = this.returnDownType(res.List.type)
                    if(res.List.type === 1){
                        this.requestTransFile(res.List.File.org_url)
                    }
                    if(type === true){
                        this.runDownload(res.List.File)
                    }else {
                        this.errorAlert(type)
                    }
                })
            }catch (e){
                console.log(e)
            }
        },
        requestTransFile(url){
            let params =  {
                "url":url,
                "key": this.postKey
            }
            axios.post(`https://xahhm4pfgc.execute-api.ap-northeast-2.amazonaws.com/flyhigh`, params).then(async (res) =>  {
            }).catch(error => {
                console.log(error);
            })
        },
        runDownload: async function (file) {
            let fileUrl = file.org_url;
            let filePath = `Justreet-Live-${file.org_name}`;
            this.downloadFile(fileUrl, filePath)

        },
        downloadFile(fileUrl, fileName) {
            try {
                if (!window.ActiveXObject) {
                    this.changeLoading(true);
                    fetch(fileUrl).then(r => r.blob()).then(blob => {
                        const a = document.createElement("a");
                        a.style.display = "none";
                        document.body.appendChild(a)
                        a.href = window.URL.createObjectURL(blob);
                        let name = fileName;
                        if(util.isEmpty(name)) {
                            name = 'video.mp4';
                        }
                        a.setAttribute("download", name);
                        a.click();
                        this.changeLoading(false);
                        window.URL.revokeObjectURL(a.href);
                        document.body.removeChild(a);

                    });
                } else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open( fileUrl, '_blank');
                    let name = fileName;
                    if(util.isEmpty(name)) {
                        name = 'video.mp4';
                    }
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, name || fileUrl)
                    _window.close();
                }
            }catch (e) {
                console.log(e)
            }
        },

        returnDownType(type){
            switch (type){
                case 1:
                    return '파일을 변환중입니다. 잠시후에 다시 시도해 주세요 '
                case 2:
                    return '파일을 변환중입니다. 잠시후에 다시 시도해 주세요'
                case 3:
                    return true
                default:
                    return "잠시후에 다시 시도해 주세요"
            }

        },

    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    watch: {},

}
</script>

<style scoped>

</style>
